import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDraggable]',
    standalone: true
})
export class DraggableDirective {
  private startX = 0;
  private startY = 0;
  private scrollTop = 0;
  private scrollLeft = 0;
  private isDragging = false;
  private scale = 1;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.scrollTop = this.elementRef.nativeElement.parentElement.scrollTop;
    this.scrollLeft = this.elementRef.nativeElement.parentElement.scrollLeft;
    this.isDragging = true;
    this.renderer.addClass(this.elementRef.nativeElement, 'dragging');
    this.renderer.setStyle(document.body, 'cursor', 'move');
    document.onmousemove = this.onMouseMove.bind(this);
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      this.renderer.removeClass(this.elementRef.nativeElement, 'dragging');
      this.renderer.setStyle(document.body, 'cursor', 'auto');
      document.onmousemove = null;
    }
  }

  private onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      const deltaX = (this.startX - event.clientX) / this.scale;
      const deltaY = (this.startY - event.clientY) / this.scale;
      this.elementRef.nativeElement.parentElement.scrollTo({
        left: this.scrollLeft + deltaX,
        top: this.scrollTop + deltaY
      });
    }
  }
}
